(function () {
  function slug(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section';
  }

  function buildToc(config) {
    var body = document.querySelector(config.bodySelector);
    if (!body) return;
    var injectInto = document.querySelector(config.injectIntoSelector);
    if (!injectInto) return;

    var headings = body.querySelectorAll('h1, h2, h3');
    if (headings.length < 2) return;

    var items = [];
    headings.forEach(function (h, i) {
      if (!h.id) h.id = slug(h.textContent) + '-' + i;
      items.push({
        id: h.id,
        text: h.textContent,
        level: h.tagName === 'H3' ? 2 : 1
      });
    });

    var toc = document.createElement('aside');
    toc.className = config.tocClass;
    toc.setAttribute('aria-label', 'Section index');

    var labelHtml =
      '<div class="' + config.tocClass + '-label"><span>Index</span></div>';

    var listHtml = '<ul class="' + config.tocClass + '-list">' +
      items.map(function (item) {
        return (
          '<li class="' + config.tocClass + '-item ' + config.tocClass + '-item--lv' +
          item.level + '">' +
          '<a href="#' + item.id + '" data-toc-link="' + item.id + '">' +
          item.text +
          '</a></li>'
        );
      }).join('') +
      '</ul>';

    toc.innerHTML = labelHtml + listHtml;

    if (config.hasTocClassTarget) {
      document.querySelector(config.hasTocClassTarget).classList.add(config.hasTocClass);
    } else {
      injectInto.classList.add(config.hasTocClass);
    }
    injectInto.insertBefore(toc, injectInto.firstChild);

    var links = toc.querySelectorAll('a[data-toc-link]');

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('data-toc-link');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
    });

    if ('IntersectionObserver' in window) {
      var current = null;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) current = entry.target.id;
          });
          if (current) {
            links.forEach(function (link) {
              link.classList.toggle(
                'is-active',
                link.getAttribute('data-toc-link') === current
              );
            });
          }
        },
        { rootMargin: '-90px 0px -70% 0px', threshold: 0 }
      );
      headings.forEach(function (h) { observer.observe(h); });
    }
  }

  function init() {
    // Shopify auto-generated policy pages
    buildToc({
      bodySelector: '.shopify-policy__body',
      injectIntoSelector: '.shopify-policy__container',
      tocClass: 'shopify-policy__toc',
      hasTocClass: 'shopify-policy__container--has-toc'
    });

    // Custom editorial pages using privacy-page section (privacy, customs, etc.)
    buildToc({
      bodySelector: '.privacy-page-section__body',
      injectIntoSelector: '.privacy-page-section__inner',
      tocClass: 'privacy-page-section__toc',
      hasTocClass: 'privacy-page-section__inner--has-toc'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
